import { render, staticRenderFns } from "./StoreRedirect.vue?vue&type=template&id=55306bbb&scoped=true&"
import script from "./StoreRedirect.vue?vue&type=script&lang=js&"
export * from "./StoreRedirect.vue?vue&type=script&lang=js&"
import style0 from "./StoreRedirect.vue?vue&type=style&index=0&id=55306bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55306bbb",
  null
  
)

export default component.exports